import { session } from '../Service/APIService';
import { generateURL } from './helper';

let t;
export const idleTimer = () => {
  async function logout() {
    const GENERIC_URL = generateURL();
    const userObj = session.user();
    if (userObj !== null) {
      const URL = `${GENERIC_URL}/member/logout/${userObj.memberId}`;

      fetch(URL).then((response) => {
        console.log(response.json());
      });
    }

    alert('you will be logged out soon');
    window.location.href = '/login'; // Adapt to actual logout script
  }
  function resetTimer() {
    clearTimeout(t);
    t = setTimeout(logout, 10800000); // time is in milliseconds (1000 is 1 second) // for 180 minutes
  }

  window.onload = resetTimer;
  window.onmousemove = resetTimer; // catches mouse movements
  window.onmousedown = resetTimer; // catches mouse movements
  window.onclick = resetTimer; // catches mouse clicks
  window.onscroll = resetTimer; // catches scrolling
  window.onkeypress = resetTimer; // catches keyboard actions
};
